import React from "react";
import { store } from "./store";
import "antd/dist/antd.css";
import "./App.css";
import DocumentDetails from "./views/DocumentDetails";
import "./styles/_main.scss";
import { Provider } from "react-redux";

const App = () => {
  return (
    <Provider store={store}>
      <DocumentDetails />
    </Provider>
  );
};

export default App;
